import React from 'react';
import AppSidebar from './AppSidebar';
import { departementCourant, niveauModule, NIVEAU_CONSULTER } from '../services/droits';
// Lot D.1 : le bandeau du super-administrateur (documents arrivés à leur durée de conservation).
import { BandeauConservation } from './DocumentsConservation';

/**
 * Bandeau affiché en haut d'un module ouvert en lecture seule.
 * Les contrôles d'écriture de chaque module seront désactivés un par un lors de
 * leur rétrofit ; en attendant, le serveur refuse l'écriture (403) et ce bandeau
 * annonce clairement la situation plutôt que de laisser l'utilisateur buter dessus.
 */
function BandeauLectureSeule() {
    return (
        <div style={{
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '8px 16px', fontSize: 13, fontWeight: 500,
            background: '#fef3c7', color: '#92400e',
            borderBottom: '1px solid #f59e0b', flexShrink: 0
        }}>
            <i className="fa-solid fa-eye" />
            <span>Mode consultation — vous pouvez consulter ce module, pas le modifier.</span>
        </div>
    );
}

/**
 * AppLayout — enveloppe standard pour tous les modules
 *
 * Fournit :
 *   - La sidebar gauche (AppSidebar)
 *   - Une zone de contenu droite scrollable, SANS marge/padding
 *     → le topbar du module enfant touche naturellement la sidebar
 *
 * Usage dans App.js :
 *   <AppLayout activeKey="monModule" user={user} config={config} onNavigate={...} onLogout={...}>
 *       <MonModule ... />
 *   </AppLayout>
 *
 * Convention pour les modules enfants :
 *   - Mettre le topbar en premier enfant, avec position: sticky; top: 0
 *   - Le contenu scrollable suit, avec son propre padding
 */
function AppLayout({
    children,
    activeKey,
    user,
    config,
    onNavigate,
    onLogout,
    annees,
    anneeId,
    onAnneeChange,
    filterKeys,
}) {
    const lectureSeule =
        niveauModule(user, departementCourant(user, config), activeKey) === NIVEAU_CONSULTER;

    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            <AppSidebar
                activeKey={activeKey}
                user={user}
                config={config}
                onNavigate={onNavigate}
                onLogout={onLogout}
                annees={annees}
                anneeId={anneeId}
                onAnneeChange={onAnneeChange}
                filterKeys={filterKeys}
            />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                <BandeauConservation user={user} />
                {lectureSeule && <BandeauLectureSeule />}
                <div style={{ flex: 1, overflow: 'auto', minWidth: 0 }}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AppLayout;
